/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { SubscriptionGateMode } from "@/lib/business-logic/billing/subscription-status";

export interface SubscriptionStateHeaderDetail {
  gate: SubscriptionGateMode;
  readOnlyUntilMs: number | null;
}

const GATE_HEADER = "x-cc-subscription-gate";
const READONLY_UNTIL_HEADER = "x-cc-subscription-read-only-until";

export function dispatchSubscriptionStateFromResponse(
  response: Response,
): void {
  if (typeof window === "undefined") return;

  const gateRaw = response.headers.get(GATE_HEADER);
  if (!gateRaw) return;

  const readUntilRaw = response.headers.get(READONLY_UNTIL_HEADER);
  const readOnlyUntilMs =
    readUntilRaw && readUntilRaw.trim() !== ""
      ? Number.parseInt(readUntilRaw, 10)
      : null;

  window.dispatchEvent(
    new CustomEvent<SubscriptionStateHeaderDetail>("subscription-state-headers", {
      detail: {
        gate: gateRaw as SubscriptionGateMode,
        readOnlyUntilMs:
          readOnlyUntilMs !== null && Number.isFinite(readOnlyUntilMs)
            ? readOnlyUntilMs
            : null,
      },
    }),
  );
}
